function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOWolontariat = function SvgOWolontariat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155.5 155.5"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h155.5v155.5H0z",
    "data-name": "Warstwa 2",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.57 99.9c0-30.04 22.38-52.04 53.18-52.04s53.18 22 53.18 52.04-23.72 52.04-53.18 52.04-53.18-21.81-53.18-52.04m53.18 30.23c16.26 0 28.89-11.67 28.89-30.23S94.01 69.67 77.75 69.67 48.86 82.1 48.86 99.9s12.63 30.23 28.89 30.23",
    "data-name": "Warstwa 1",
    style: {
      fill: "#5ea570"
    }
  }));
};
export default SvgOWolontariat;